import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  ChartTypePersistedAtom,
  drawingAtom,
  market2resolutionAtom,
  indicatorCountAtom,
  currentPriceAtom,
} from '../atoms/chartAtoms';

// Chart type persisted hook
export function useChartTypePersisted() {
  return useRecoilState(ChartTypePersistedAtom);
}

// Drawing atom hook
export function useDrawing() {
  return useRecoilState(drawingAtom);
}

// Market to resolution hook
export function useMarket2Resolution() {
  return useRecoilState(market2resolutionAtom);
}

// Indicator count hook
export function useIndicatorCount() {
  const [indicatorCount, setIndicatorCount] = useRecoilState(indicatorCountAtom);

  const incrementIndicatorCount = () => {
    setIndicatorCount(prev => prev + 1);
  };

  const resetIndicatorCount = () => {
    setIndicatorCount(0);
  };

  return [indicatorCount, incrementIndicatorCount, resetIndicatorCount] as const;
}

// Set-only hooks for convenience
export function useSetChartTypePersisted() {
  return useSetRecoilState(ChartTypePersistedAtom);
}

export function useSetDrawing() {
  return useSetRecoilState(drawingAtom);
}

export function useSetMarket2Resolution() {
  return useSetRecoilState(market2resolutionAtom);
}

export function useSetIndicatorCount() {
  return useSetRecoilState(indicatorCountAtom);
}

// Read-only hooks
export function useChartTypePersistedValue() {
  return useRecoilValue(ChartTypePersistedAtom);
}

export function useDrawingValue() {
  return useRecoilValue(drawingAtom);
}

export function useMarket2ResolutionValue() {
  return useRecoilValue(market2resolutionAtom);
}

export function useIndicatorCountValue() {
  return useRecoilValue(indicatorCountAtom);
}

export const useCurrentPrice = () => {
  const [currentPrice, setCurrentPrice] = useRecoilState(currentPriceAtom);
  return [currentPrice, setCurrentPrice] as const;
};